import * as mutationTypes from '../../types/mutationTypes';
// import { logger } from '../../tools/logger';
import { viewSize } from '../../tools/consts';
export default store => {
	// called when the store is initialized
	let lastWidth;
	let lastHeight;
	function onWindowResize(event) {
		function sizeToClass(size) {
			// logger.log('sizeToClassName ' + size);
			if (size < 360) return viewSize.xxsmall;
			if (size < 414) return viewSize.xsmall;
			if (size < 520) return viewSize.small;
			if (size < 768) return viewSize.medium;
			if (size < 1024) return viewSize.large;
			return viewSize.xlarge;
		}
		if (lastWidth !== event.target.innerWidth || lastHeight !== event.target.innerHeight) {
			lastWidth = event.target.innerWidth;
			lastHeight = event.target.innerHeight;

			store.commit(mutationTypes.setViewportSize, {
				size: sizeToClass(Math.min(...[lastWidth, lastHeight])),
			});
			store.commit(mutationTypes.setViewportMode, {
				mode: event.target.innerWidth > event.target.innerHeight ? 'landscape' : 'portrait',
			});
		}
	}
	window.addEventListener('resize', onWindowResize);
	onWindowResize({ target: { innerWidth: window.innerWidth, innerHeight: window.innerHeight } });

	// store.subscribe((mutation, state) => {});
};
